<template>
  <Header @onPrintHandler="printHandler" @onMenuHandler="onMenuHandler" :lotteryName="lotteryName" />
  <template v-if="currentLottery">
    <Tag :endTime="currentLottery?.endTime" />
    <div class="container">
      <div class="current">
        <h3 class="num">{{ currentNum }}</h3>
        <div class="l1">{{ $t('home.paga') }}:{{ currentLottery?.mAmount }}</div>
        <div class="l1">{{ $t('home.saldo') }}:{{ currentNumberRestricted }}</div>
        <div class="l1">{{ $t('home.monto') }}:{{ mAmountTotal }}</div>
        <div class="l1" v-if="rAmountTotal > 0">{{ $t('home.rMonto') }}:{{ rAmountTotal }}</div>
        <div class="l1">{{ $t('home.total') }}:{{ allTotal }}</div>
        <van-checkbox
          v-if="currentLottery?.rEnabled !== 0"
          v-model="isSecond"
          shape="square"
          @change="changeSecondHandler"
        >{{ $t('home.reventados') }}</van-checkbox>
        <!-- <div v-if="isSecond" class="second-amount">第二个金额:{{ secondAmount }}</div> -->
      </div>
      <ul class="history">
        <table class="table" cellpadding="0" cellspacing="0">
          <tr>
            <td>{{ $t('home.colNum') }}</td>
            <td>{{ $t('home.colAmount') }}</td>
            <td v-if="currentLottery?.rEnabled !== 0">{{ $t('home.colReve') }}</td>
            <td></td>
          </tr>
          <tr v-for="(item, index) of selectLotteryList" :key="index">
            <td>{{ item.num }}</td>
            <td>{{ item.mAmount }}</td>
            <td v-if="currentLottery?.rEnabled !== 0">{{ item.rAmount }}</td>
            <td>
              <img src="./../../assets/images/delete.png" class="delete" @click="deleteLotteryItem(index)" />
            </td>
          </tr>
        </table>
      </ul>
    </div>
  </template>

  <!-- 侧边栏导航开始 -->
  <aside class="left_cate" id="left_cate">
    <ul class="group">
      <van-radio-group v-model="checked" @click="lotteryItemChange">
        <van-radio v-for="item of lotteryList" :key="item.id" :name="item.id" style="margin-bottom: 1.33333vw">{{ item.name }}</van-radio>
      </van-radio-group>
    </ul>
    <!-- <div id="nav_cate" class="nav_cate">
      <img src="./../../assets/images/nav.png" />
    </div> -->
  </aside>
  <div class="bg" id="bg"></div>
  <!-- 侧边栏导航结束 -->
  <div class="footer">
    <div class="left">
      <NumberKey @onSelectNumItem="selectNumItem" />
    </div>
    <div class="right">
      <MoneyKey @onSelectMoneyItem="selectMoneyItem" />
    </div>
  </div>
  <!-- 打印弹出层 -->
  <van-popup v-model:show="show" closeable close-icon="close" position="bottom" :style="{ height: '50%' }">
    <h3>{{ $t('home.betList') }}</h3>
    <div class="popup">
      <template v-if="selectLotteryList.length">
        <table class="table" cellpadding="0" cellspacing="0">
          <tr>
            <td>{{ $t('home.colSorteo') }}</td>
            <td>{{ $t('home.colNum') }}</td>
            <td>{{ $t('home.colAmount') }}</td>
            <td v-if="currentLottery?.rEnabled !== 0">{{ $t('home.colReve') }}</td>
          </tr>
          <tr v-for="(item, index) of selectLotteryList" :key="index">
            <td>{{ item.name }}</td>
            <td>{{ item.num }}</td>
            <td>{{ item.mAmount }}</td>
            <td v-if="currentLottery?.rEnabled !== 0">{{ item.rAmount }}</td>
          </tr>
        </table>
      </template>
      <img v-else src="./../../assets/images/not_data.png" class="img" />
      <van-button size="small" type="primary" class="confirm-btn brand-btn" :loading="loading" @click="confirmOrder">{{ $t('home.order') }}</van-button>
    </div>
  </van-popup>
</template>

<script setup>
import { ref, watch, onMounted, computed } from 'vue';
import { Toast, Dialog } from 'vant';
import { useRouter } from 'vue-router';
import { LotteryService, OrderService } from '@/services';
import Header from './components/Header';
import Tag from './components/Tag';
import NumberKey from './components/NumberKey';
import MoneyKey from './components/MoneyKey';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const router = useRouter();
const currentNum = ref('');
const flag = ref(true);
const checked = ref(1); // 当前选中的彩票
const isSecond = ref(false);
const secondAmount = ref('');
const isSelectAmount = ref(false);
const allTotal = ref(0); // 总金额
const mAmountTotal = ref(0); // m金额
const rAmountTotal = ref(0); // r金额
const show = ref(false);
const selectLotteryList = ref([]); // 已选的彩票列表
const lotteryList = ref([]); // 彩票列表
const lotteryRestrictedList = ref([]); // 彩票限额
const currentLottery = ref(); // 当前彩票信息
const lotteryName = ref(''); // 彩票名称
const loading = ref(false);

// 初始化彩票列表
const initLotterty = async () => {
  const { result } = await LotteryService.lotteryListApi();
  lotteryList.value = result;
  if (result.length) {
    // 默认选中第一条数据
    checked.value = result[0].id;
    currentLottery.value = result[0];
    // 查询当前的彩票限额
    await lotteryRestrictedByLottery(result[0].id);
    lotteryName.value = result[0].name;
  } else {
    lotteryName.value = t('home.noLottery');
  }
};
// 根据彩票id去查询彩票限额
const lotteryRestrictedByLottery = async (lotteryId) => {
  const { result } = await LotteryService.LotteryRestrictedByLotteryApi(lotteryId);
  lotteryRestrictedList.value = result;
};

// 提交彩票
const confirmOrder = async () => {
  if (selectLotteryList.value.length) {
    console.log('提交订单', selectLotteryList.value);
    const data = [];
    for (const item of selectLotteryList.value) {
      data.push({
        lotteryId: item.id,
        lotterName: item.name,
        num: item.num,
        mAmount: item.mAmount,
        rAmount: item.rAmount,
      });
    }
    loading.value = true;
    const { code, result } = await OrderService.createOrderApi({
      orderListDtail: data,
      lotteryId: selectLotteryList.value[0].id,
      lotterName: selectLotteryList.value[0].name,
    });
    if (Object.is(code, 0)) {
      Toast.success(t('home.orderSuccess'));
      setTimeout(() => {
        router.push({ path: '/successOrder', query: { orderId: result } });
      });
    } else {
      Toast.fail(t('home.orderFail'));
    }
    loading.value = false;
  } else {
    Toast(t('home.selectLottery'));
  }
};
// 打印
const printHandler = () => {
  show.value = true;
};
// 删除彩票
const deleteLotteryItem = (index) => {
  selectLotteryList.value.splice(index, 1);
};
// 选择第二个金额的时候
const changeSecondHandler = (isChecked) => {
  console.log(isChecked);
  // 判断是否已经有数字的时候
  if (currentNum.value && isSelectAmount.value) {
    isSecond.value = isChecked;
    Toast(t('home.enterAmountRight'));
  } else {
    Toast(t('home.selectNumAndAmount'));
    isSecond.value = false;
  }
};
// 选择彩票
const lotteryItemChange = async () => {
  //分类
  const leftCate = document.getElementById('left_cate');
  //背景
  const bg = document.getElementById('bg');
  leftCate.style.transform = 'translate(-100%,0)';
  bg.style.display = 'none';
  flag.value = true;
  currentNum.value = '';
  // 切换当前选中的彩票
  currentLottery.value = lotteryList.value.find((item) => item.id == checked.value);
  // 如果新彩票禁用了 R,则关掉"Reventados"复选框
  if (currentLottery.value && currentLottery.value.rEnabled === 0) {
    isSecond.value = false;
  }
  // 当前彩票名称
  lotteryName.value = currentLottery.value.name;
  // 根据彩票去获取限额数量
  await lotteryRestrictedByLottery(checked.value);
};
// 选择数字
const selectNumItem = (item) => {
  currentNum.value += String(item);
  isSelectAmount.value = false;
  isSecond.value = false;
  secondAmount.value = '';
  if (currentNum.value.length > 2) {
    const current = currentNum.value.split('');
    current.shift();
    current.shift();
    currentNum.value = current.join('');
    return;
  }
};
// 选择金额
const selectMoneyItem = (item) => {
  if (currentNum.value) {
    const currentNumber = currentNum.value.length == 1 ? `0${currentNum.value}` : currentNum.value;
    // 追加到列表中,先判断这个数字是否存在，存在就累加金额
    const findItem = selectLotteryList.value.find((item) => item.num == currentNumber);
    const index = selectLotteryList.value.findIndex((item) => item.num == currentNumber);
    if (!isSecond.value) {
      if (findItem) {
        selectLotteryList.value.splice(index, 1, {
          num: currentNumber,
          mAmount: findItem.mAmount + item,
          rAmount: findItem.rAmount,
          id: checked.value,
          name: lotteryList.value.find((item) => item.id == checked.value).name,
        });
      } else {
        selectLotteryList.value.push({
          num: currentNumber,
          mAmount: item,
          rAmount: 0,
          id: checked.value,
          name: lotteryList.value.find((item) => item.id == checked.value).name,
        });
      }
      isSelectAmount.value = true;
    } else {
      console.log('追加第二个金额', item);
      secondAmount.value = item;
      if (findItem) {
        selectLotteryList.value.splice(index, 1, {
          num: currentNumber,
          mAmount: findItem.mAmount,
          rAmount: findItem.rAmount + item,
          id: checked.value,
          name: lotteryList.value.find((item) => item.id == checked.value).name,
        });
      }
    }
  } else {
    Toast(t('home.selectNum'));
  }
};
const onMenuHandler = () => {
  //分类
  const leftCate = document.getElementById('left_cate');
  //背景
  const bg = document.getElementById('bg');
  const toggleHandler = () => {
    if (flag.value) {
      flag.value = false;
      leftCate.style.transform = 'translate(0,0)';
      bg.style.display = 'block';
    } else {
      flag.value = true;
      leftCate.style.transform = 'translate(-100%,0)';
      bg.style.display = 'none';
    }
  };
  // 提示是否要切换产品
  if (selectLotteryList.value.length) {
    Dialog.confirm({
      title: t('home.changeProductTitle'),
      message: t('home.changeProductMessage'),
    })
      .then(() => {
        console.log('切换产品');
        selectLotteryList.value = [];
        toggleHandler();
        // on confirm
      })
      .catch(() => {
        console.log('取消切换');
        // on cancel
        return;
      });
  } else {
    toggleHandler();
  }
};

// 根据当前选中的号码计算限额
const currentNumberRestricted = computed(() => {
  if (currentNum.value) {
    const _currentNum = currentNum.value.length < 2 ? `0${currentNum.value}` : currentNum.value;
    const item = lotteryRestrictedList.value.find((item) => item.num == _currentNum);
    return Number(item.max) - item.sellAmount;
  } else {
    return '';
  }
});
// 监听变化,计算总金额
watch(
  selectLotteryList,
  (newVal) => {
    mAmountTotal.value = newVal.reduce((cur, next) => {
      return cur + next.mAmount;
    }, 0);
    rAmountTotal.value = newVal.reduce((cur, next) => {
      return cur + next.rAmount;
    }, 0);
    allTotal.value = mAmountTotal.value + rAmountTotal.value;
  },
  {
    deep: true,
  },
);
onMounted(() => {
  initLotterty();
});
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: row;
  margin-top: 50px;
  padding: 30px;
  box-sizing: border-box;
  .current,
  .history {
    flex: 1;
  }
  .history {
    height: 600px;
    overflow-y: auto;
    .delete {
      width: 40px;
      display: inline-block;
      text-align: center;
    }
  }
  .current {
    .num {
      font-size: 100px;
      margin-bottom: 20px;
    }
    .l1 {
      margin-bottom: 20px;
    }
  }

  .second-amount {
    height: 50px;
    margin-top: 10px;
  }
}
.footer {
  position: fixed;
  width: 100%;
  height: 370px;
  left: 0;
  bottom: 100px;
  display: flex;
  flex-direction: row;
  .left {
    flex: 1;
  }
  .right {
    flex: 1;
  }
}

// 侧边栏样式
.left_cate {
  /*css3运动  加过渡效果*/
  transition: all 1s;
  transform: translate(-100%, 0);
  z-index: 2;
  width: 300px;
  height: 100%;
  position: fixed;
  background: #eee;
  top: 0px;
  left: 0px;
  .group {
    position: absolute;
    height: 100%;
    padding: 30px 20px;
    box-sizing: border-box;
    z-index: 3;
    background: #eee;
    overflow-y: auto;
    li {
      height: 50px;
      line-height: 50px;
    }
  }

  .nav_cate {
    position: absolute;
    right: -80px;
    background: rgba(132, 128, 128, 0.9);
    top: 14%;
    width: 80px;
    height: 80px;
    text-align: center;
    border-radius: 0px 50% 50% 0px;
    z-index: 2;
    img {
      width: 64px;
      height: 64px;
      margin-left: 1px;
      margin-top: 8px;
    }
  }
}
.bg {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  left: 0px;
  top: 0px;
  z-index: 1;
  display: none;
}
.popup {
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  position: relative;
  height: 86%;
  ul {
    height: 84%;
    overflow-y: auto;
  }
  li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .confirm-btn {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
  .img {
    width: 400px;
    display: block;
    margin: 20px auto;
  }
}
.table {
  width: 100%;
}
</style>
